import { render } from "./MBottomNav.vue?vue&type=template&id=17f8717e"
import script from "./MBottomNav.vue?vue&type=script&lang=ts"
export * from "./MBottomNav.vue?vue&type=script&lang=ts"
script.render = render

export default script